import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const placeImporterSelectors = importerSelectors(
  'place.importer',
);

export default placeImporterSelectors;
